import * as types from './types';

/**
 * ---------------------------------------------------
 *  GET USUÁRIOS DO SISTEMA
 * ---------------------------------------------------
 */

export function getUsersRequest(payload) {
  return {
    type: types.GET_USERS_REQUEST,
    payload,
  };
}

export function getUsersSuccess(payload) {
  return {
    type: types.GET_USERS_SUCCESS,
    payload,
  };
}

export function getUsersFailure(payload) {
  return {
    type: types.GET_USERS_FAILURE,
    payload,
  };
}


/**
 * ---------------------------------------------------
 *  CADASTRO DE USUÁRIOS
 * ---------------------------------------------------
 */

export function newUsersRequest(payload) {
  return {
    type: types.NEW_USERS_REQUEST,
    payload,
  };
}

export function newUsersSuccess(payload) {
  return {
    type: types.NEW_USERS_SUCCESS,
    payload,
  };
}

export function newUsersFailure(payload) {
  return {
    type: types.NEW_USERS_FAILURE,
    payload,
  };
}
